var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { regionService } from 'ziphy-web-shared/basic/api';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { useForm } from 'ziphy-web-shared/basic/lib/forms';
import MultiSelect from 'ziphy-web-shared/basic/lib/forms/fields/multiSelect/LegacyMultiSelect';
import { Loader } from 'ziphy-web-shared/basic/lib/loaders';
import styles from './ProgramsView.module.scss';
import { ExploreCard } from './ui/ExploreCard/ExploreCard';
const ProgramsView = () => {
    const { t } = useTranslation();
    const { form } = useForm({
        state: { value: undefined },
        tab: { value: undefined }
    });
    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState();
    const [availableServices, setAvailableServices] = useState([]);
    const [programs, setPrograms] = useState([]);
    const { isLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        let tmp = regions;
        if (!regions.length) {
            const { prepared } = yield regionService.listAvailable();
            tmp = ((_b = (_a = prepared.regions) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.sort((a, b) => a.name.localeCompare(b.name))) || [];
            setRegions(tmp);
            form.fields.state.setValue(tmp[0].name);
        }
        const region_id = (_c = tmp.find(el => el.name == form.fields.state.value)) === null || _c === void 0 ? void 0 : _c.id;
        if (region_id) {
            const { prepared: { liveqServices: { items: liveqServices }, liveqPrograms: tmpPrograms } } = yield regionService.availableLiveqServicesByRegion({ region_id: parseInt(region_id) });
            setRegionId(parseInt(region_id));
            setAvailableServices(liveqServices.sort((a, b) => a.id - b.id));
            setPrograms(tmpPrograms);
        }
    }), [form.fields.state.value]);
    const exploreItems = availableServices.map(el => {
        var _a;
        return ({
            type: el.id,
            name: el.displayName,
            program: (_a = programs.find(item => item.id === el.liveqProgramId)) === null || _a === void 0 ? void 0 : _a.name,
            onClick: () => { }
        });
    });
    return (_jsxs("div", Object.assign({ className: styles.contentWrapper }, { children: [_jsx("div", Object.assign({ className: styles.city }, { children: _jsx(MultiSelect, { label: t('label.state_of_residence'), items: regions.map((x) => ({ id: x.name, text: x.name })), field: isLoading ? { value: '' } : form.fields.state, placeholder: t('label.loading'), mode: "lg" }) })), _jsx("div", Object.assign({ className: styles.content }, { children: isLoading ? _jsx(Loader, {}) : exploreItems.map((item) => (_jsx(ExploreCard, Object.assign({}, item, { link: `/explore/booking/${item.type}/${regionId}` }), item.type.toString()))) }))] })));
};
export default observer(ProgramsView);
